<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>应用分类信息</span>
      </div>
      <el-form
        ref="dictionariesCategoryForm"
        :model="dictionariesCategoryInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <span>应用分类一旦新增，生成数据后将无法删除，请谨慎操作</span>
        </div>
        <br />
        <div class="add-form-item">
          <el-form-item label="节点标识数字：" prop="applicationCategoryCode">
            <el-input
              v-model="dictionariesCategoryInfo.applicationCategoryCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="应用分类名称：" prop="applicationCategoryName">
            <el-input
              v-model="dictionariesCategoryInfo.applicationCategoryName"
            ></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      dictionariesCategoryInfo: {
        applicationCategoryId: "",
        applicationCategoryName: "",
        applicationCategoryCode: ""
      },
      rules: {
        applicationCategoryName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getApplicationCategoryCodeMax: function() {
      let _this = this;
      let param = {
        url: "/api/dictionaryCategory/getApplicationCategoryCodeMax"
      };

      _this.$store.dispatch("getApplicationCategoryCodeMax", param).then(() => {
        _this.dictionariesCategoryInfo =
          _this.$store.state.dictionaries.applicationCategoryCodeMax.dictionariesCategoryInfo;
        _this.$store.state.dictionaries.applicationCategoryCodeMax.dictionariesCategoryInfo.applicationCategoryCode =
          Number(
            _this.$store.state.dictionaries.applicationCategoryCodeMax
              .dictionariesCategoryInfo.applicationCategoryCode
          ) + 1;
      });
    },
    add: function() {
      let _this = this;
      _this.$refs.dictionariesCategoryForm.validate(isPass => {
        if (isPass) {
          let param;
          param = {
            url: "/api/dictionaryCategory/saveDictionaryCategoryInfo",
            params: {
              applicationCategoryName:
                _this.dictionariesCategoryInfo.applicationCategoryName,
              applicationCategoryCode:
                _this.dictionariesCategoryInfo.applicationCategoryCode
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "应用分类信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "categoryIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善应用分类信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    _this.getApplicationCategoryCodeMax();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
